import { listToCsv } from 'modules/list-to-csv/list-to-csv';
import FileSaver from 'file-saver';

export const useListToCsv = () => {
  const saveCSVFromList = (list, columns) => {
    const blob = new Blob(['\uFEFF' + listToCsv(list, columns)], {
      type: 'text/csv;charset=utf-8',
    });
    FileSaver.saveAs(blob, `retry-shipments_${Date.now()}.csv`);
  };

  return { saveCSVFromList };
};
